package pl.decks.personal.components.widgets.timeline

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.silk.style.toModifier

object MonthMarkers {

    @Composable
    fun RoundedBar(modifier: Modifier = Modifier) =
        Box(MonthlyTimelineStylesheet.RoundedBarMarker.toModifier().then(modifier))

    @Composable
    fun Circle(modifier: Modifier = Modifier) =
        Box(MonthlyTimelineStylesheet.CircleMarker.toModifier().then(modifier))
}
